import { createActionConst } from '../../../utils/action.utils';

const HOME_NAMESPACE = 'HOME';

export const INITIAL_HOME_PAGE = createActionConst(HOME_NAMESPACE, 'INITIAL_HOME_PAGE');

export const INITIAL_BOARDS_FOR_MEETING = createActionConst(HOME_NAMESPACE, 'INITIAL_BOARDS_FOR_MEETING');
